/* eslint-disable no-alert */
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Row, Col, Spinner, Alert, Card, CardBody, CardTitle,
} from 'reactstrap';

import { withTranslation } from 'react-i18next';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

// import { post } from '../../helpers/api_helper';
import * as url from '../../helpers/url_helper';
import { get } from '../../helpers/api_helper';
import DirectoryEntryCard from './card';
import ContactForm from '../../components/Directory/ContactForm';

function ViewEntry(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  // eslint-disable-next-line no-unused-vars
  const { t } = props;
  const { id } = useParams();

  const [data, setData] = useState({
    id: null,
    name: '',
    company: '',
    phone: '',
    email: '',
    addresses: [],
    notes: '',
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [reload, setReload] = useState(1);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const entry = await get(`${url.GET_DIRECTORY_ENTRY}/${id}`);

        setData(entry);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };

    setLoading(true);
    fetchData();
  }, [id, reload]);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xl="4">
            {data !== null && <DirectoryEntryCard entity={data} />}
            {loading && <Spinner style={{ width: '4rem', height: '4rem' }} type="border" color="info" />}
            {error !== false && <Alert color="danger" className="mt-3" isOpen>{error}</Alert>}
          </Col>

          <Col xl="8">
            <Row>
              <Col md="4">
                <Card className="mini-stats-wid">
                  <CardBody>
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium mb-2">
                          {t('Revenue')}
                        </p>
                        <h4 className="mb-0">$0</h4>
                      </div>

                      <div className="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary">
                        <span className="avatar-title">
                          <i
                            className="mdi mdi-currency-usd font-size-24"
                          />
                        </span>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col md="4">
                <Card className="mini-stats-wid">
                  <CardBody>
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium mb-2">
                          {t('Orders Received')}
                        </p>
                        <h4 className="mb-0">0</h4>
                      </div>

                      <div className="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary">
                        <span className="avatar-title">
                          <i
                            className="mdi mdi-truck-check font-size-24"
                          />
                        </span>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col md="4">
                <Card className="mini-stats-wid">
                  <CardBody>
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium mb-2">
                          {t('Sales Completed')}
                        </p>
                        <h4 className="mb-0">0</h4>
                      </div>

                      <div className="mini-stat-icon avatar-sm align-self-center rounded-circle bg-danger">
                        <span className="avatar-title">
                          <i
                            className="mdi mdi-account-cash font-size-24"
                          />
                        </span>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Card>
              <CardBody>
                <CardTitle className="h4">{t('Edit Contact Information')}</CardTitle>
                <ContactForm
                  entity={data}
                  onSuccess={
                    () => {
                      setReload(reload + 1);
                    }
                  }
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

ViewEntry.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(ViewEntry));
